/* Built In Imports */

/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import TopKolam from '@components/Headings/TopKolam';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import config from '@config';
import { useRouter } from 'next/router';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from 'react-share';
/* Internal Imports */
/* Components */

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 * 
 */
const SharePage = ({ section, region, language }) => {
    const router = useRouter();
    const url = router.asPath;
    return (
        <Box
            margin={{
                base: "60px 0px 0px  0",
                sm: "60px 0px 0px  0",
                lg: "80px 0px 0px  0",
            }}
            display={"flex"}
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
        >
            <Box
                width={{ base: "320px", sm: "320px", lg: "337px" }}
            >
                <Box display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    fontSize={"24px"}
                    fontWeight={"bold"}

                >
                    <Box>
                        {section[0]?.titleText.slice(0, 16)}
                    </Box>
                    <Box>
                        {section[0]?.titleText.slice(16)}
                    </Box>
                </Box>
                <Box
                    margin={"8px 0px 26px 0px"}
                    color={"#676055"}
                    textAlign={"center"}
                    fontSize={"18px"}
                >
                    {StructuredTextContent(section[1].body)}
                </Box>
                <Box display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    marginBottom={{ sm: "0px", base: "0px", lg: "40px" }}
                >
                    {/* {[2, 3, 4, 5, 6, 7].map((index) => (
                        <Link key={index}
                            href=""
                        //  href={section[index]?.image?.link}
                        >
                            <LazyLoadImageComponent
                                marginRight={{ base: "19px", sm: "19px", lg: "22px" }}
                                alt={section[index]?.image?.alt}
                                height={section[index]?.image?.height}
                                title={section[index]?.image?.title}
                                width={section[index]?.image?.width}
                                src={section[index]?.image?.url}
                            />
                        </Link>
                    ))} */}
                    <WhatsappShareButton
                        url={`${config.BASE_PATH}${url}`}
                        quote={''}
                    >
                        <Image
                            marginRight={{ base: "19px", sm: "19px", lg: "22px" }}
                            alt={section[2]?.image?.alt}
                            title={section[2]?.image?.title}
                            src={section[2]?.image?.url}
                        />

                    </WhatsappShareButton>
                    <LinkedinShareButton
                        url={`${config.BASE_PATH}${url}`}
                        quote={''}
                    >
                        <Image
                            marginRight={{ base: "19px", sm: "19px", lg: "22px" }}
                            alt={section[3]?.image?.alt}
                            title={section[3]?.image?.title}
                            src={section[3]?.image?.url}
                        />

                    </LinkedinShareButton>
                    <TwitterShareButton
                        url={`${config.BASE_PATH}${url}`}
                        quote={''}
                    >
                        <Image
                            marginRight={{ base: "19px", sm: "19px", lg: "22px" }}
                            alt={section[4]?.image?.alt}
                            title={section[4]?.image?.title}
                            src={section[4]?.image?.url}
                        />

                    </TwitterShareButton>
                    <EmailShareButton
                        url={`${config.BASE_PATH}${url}`}
                        quote={''}
                    >
                        <Image
                            marginRight={{ base: "19px", sm: "19px", lg: "22px" }}
                            alt={section[5]?.image?.alt}
                            title={section[5]?.image?.title}
                            src={section[5]?.image?.url}
                        />
                    </EmailShareButton>
                    <FacebookShareButton
                        url={`${config.BASE_PATH}${url}`}
                        quote={''}
                    >
                        <Image
                            marginRight={{ base: "19px", sm: "19px", lg: "22px" }}
                            alt={section[6]?.image?.alt}
                            title={section[6]?.image?.title}
                            src={section[6]?.image?.url}
                        />

                    </FacebookShareButton>


                </Box>
                <TopKolam sectionContent={section[7]} />
            </Box>
        </Box>
    );
};

export default SharePage;
